module.exports = __webpack_public_path__ + "img/bg.16088a60.jpg";